

<template>
  <!-- Error Page Area Start -->
  <div class="error-page-area">
    <img src="../assets/img/shape_10.png" alt="shape" class="shape_10">
    <img src="../assets/img/shape_12.png" alt="shape" class="shape_12">
    <img src="../assets/img/shape_14.png" alt="shape" class="shape_14">
    <img src="../assets/img/shape_15.png" alt="shape" class="shape_15">
    <img src="../assets/img/shape_16.png" alt="shape" class="shape_16">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="login_inn">
            <div class="login-wrapper">
              <img class="login_icon" src="../assets/img/login.png" alt="login user" />
              <h3>Account Login</h3>
              <form>
                <div class="form-row">
                  <input type="text" placeholder="Username or Email" />
                </div>
                <div class="form-row">
                  <input type="password" placeholder="Password" />
                </div>
                <div class="form-row"></div>
                <div class="form-row">
                  <button type="submit">Login to your Account!</button>
                </div>
              </form>
              <div class="socials-wrapper">
                <p>Login with your Social Account</p>
                <ul>
                  <li><a href="#" class="facebook"><i class="fab fa-facebook-f"></i></a></li>
                  <li><a href="#" class="twitter"><i class="fab fa-twitter"></i></a></li>
                  <li><a href="#" class="twitch"><i class="fab fa-twitch"></i></a></li>
                  <li><a href="#" class="youtube"><i class="fab fa-youtube"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Error Page Area End -->
</template>
<script>
export default {
  name: 'Login'
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue